export default {
  label: {
    updateBy: 'Modified by',
    updateDate: 'Modification time',
    createAcct: 'founder',
    createTime: 'Creation time',
    merchantNo: 'business number',
    updateAcct: 'updater',
    updateTime: 'Update time',
    walletAmount: 'Wallet amount',
    walletType: 'wallet type',
    momo: 'Momo',
    zalo: 'Zalo',
    vtp: 'Viettel pay',
    vtpFix: 'Viettel pay fix',
    bankOnline: 'Bank online',
    transfer: 'Bank transfer',
    bankQr: 'Bank QR',
    all: 'All',
    card: 'Card',
    payout: 'Payout',
    allMerchantBalance: '商户总余额',
    todayPayoutAmount: "Today's withdrawal amount",
    todayBalanceAmount: 'Total wallet balance',
    todayTradeAmount: "Today's transaction amount",
    yesterdayTradeAmount: "Yesterday's transaction amount"
  },
  rules: {
    walletType: 'The wallet type cannot be empty!'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/merchantBalance.js